<script setup lang="ts">
import { UiCompanyOverallNonRespondant } from '#components'

const { id } = useRoute().params

const { state } = useAppStore()

const { data: companyPub, error: error } = await useFetch<any>(`/api/data/company/${id}`)
const { data: categories } = await useFetch<any>(`/api/data/categories`)

if (error.value) {
    console.log
    console.error(error.value)
}

console.log('Company Pub', companyPub.value)

const { data: positionData, error: errorPosition } = await useFetch<any>(`/api/data/company/positions/${id}`)

if (errorPosition.value) {
    console.log(errorPosition.value)
}

console.log('Position Data', positionData.value)

const { data: pastScores, error: errorPastScores } = await useFetch<any>(`/api/data/company/${id}/history`)

if (errorPastScores.value) {
    console.log(errorPastScores.value)
}

console.log('Past Scores', pastScores.value)

/* const onGoBack = () => {
    navigateTo('/scorecards')
} */
</script>

<template>
    <div v-if="companyPub">
        <UiPageHeader
            :eyebrow="useText(state.strings, 'sc_edition')"
            :title="companyPub.name"
            :button-label="useText(state.strings, 'sc_back')"
            :button-icon="'i-lucide-move-left'"
            button-link="/scorecards"
        />
        <CompanyMeta :company="companyPub" />
        <CompanyPublicStats
            v-if="companyPub.scores.length"
            :company-pub="companyPub"
        />
        <UiCompanyOverallNonRespondant v-if="companyPub.scores.length == 0" />
        <CompanyPosition v-if="companyPub.scores.length" />
        <CompanyPublicVolume :company-pub="companyPub" />
        <CompanyPublicProductLines :company-pub="companyPub" />
        <CompanyPublicPastScores
            :company-pub="companyPub"
            :categories="categories"
        />
    </div>
</template>
